// extracted by mini-css-extract-plugin
export var hidden = "_4t-1";
export var leftPanel = "_4t-2";
export var readonlyInspector = "_4t-3";
export var rightPanel = "_4t-0";